import ApiService from 'api-client/ApiService'
import config from 'app-config'

// Multi-host support bundle APIs served directly by sidekick (keystone
// authenticated), registered in the catalog as the "sidekick" service.
class Sidekick extends ApiService {
  public getClassName() {
    return 'sidekick'
  }

  static apiMethodsMetadata = []

  protected async getEndpoint() {
    const endpoint = await this.client.keystone.getServiceEndpoint('sidekick', 'public')
    if (endpoint) {
      return `${endpoint.replace(/\/+$/, '')}/v1`
    }
    // A region whose keystone upgrade ran before Infra registered the sidekick
    // service has no endpoints yet; sidekick is still served at /sidekick
    // on the same FQDN as that region's resmgr.
    const resmgrEndpoint = await this.client.keystone.getServiceEndpoint('resmgr', 'public')
    let origin = config.apiHost
    if (resmgrEndpoint) {
      try {
        origin = new URL(resmgrEndpoint).origin
      } catch (error) {
        console.warn(`Failed to parse resmgr endpoint URL: ${resmgrEndpoint}`, error)
      }
    }
    return `${origin}/sidekick/v1`
  }

  async generateSupportBundle({ body }: { body: { hostIds: string[] } }) {
    return this.client.basicPost({
      url: '/bundle/multi',
      body,
      options: {
        clsName: this.getClassName(),
        mthdName: 'generateSupportBundle',
      },
    })
  }

  async getSupportBundleStatus({ bundleId }: { bundleId: string }) {
    return this.client.basicGet({
      url: `/bundle/multi/${encodeURIComponent(bundleId)}`,
      options: { clsName: this.getClassName(), mthdName: 'getSupportBundleStatus' },
    })
  }

  async downloadSupportBundle({ bundleId }: { bundleId: string }): Promise<Blob> {
    const endpoint = await this.getApiEndpoint()
    const url = `${endpoint}/bundle/multi/${encodeURIComponent(bundleId)}/download`

    // Make direct axios call to avoid response transformations that convert blob to string
    const response = await this.client['axiosInstance'].get<Blob>(url, {
      responseType: 'blob',
      headers: {
        'X-Auth-Token': this.client['getAuthHeaders']().headers['X-Auth-Token'],
        Accept: 'application/octet-stream, application/zip, */*',
      },
    })

    return response.data
  }

  async cancelSupportBundle({ bundleId }: { bundleId: string }) {
    return this.client.basicPost({
      url: `/bundle/multi/${encodeURIComponent(bundleId)}/cancel`,
      options: {
        clsName: this.getClassName(),
        mthdName: 'cancelSupportBundle',
      },
    })
  }
}

export default Sidekick
